module.exports = __webpack_public_path__ + "broomstick.png?f1d6336786a8cb3a7b29b427a189e6e8";